<div class="component-content">
  <div id="empty-details">    
    <mat-icon class="details-empty-background" svgIcon="details-empty-background"></mat-icon>    
    <mat-icon class="details-empty-icon"  svgIcon="details-empty-icon"></mat-icon>
    <p>{{primaryText}}</p>
    <p>{{secondaryText}}</p>
  </div>
</div>
